// Species label: common and scientific name on a bark pill, fading in a
// couple of seconds after the butterfly has settled (HANDOVER open question
// 3: built so it can be switched off in config without touching anything).
import { config } from '../config.js';
import { getLanguage, onLanguageChange } from '../i18n/index.js';
import { el } from '../debug/controls.js';

export function createLabel(app, { speciesById }) {
  const common = el('span', { class: 'label__common' });
  const sci = el('span', { class: 'label__sci' });
  const root = el('div', { class: 'label', 'aria-live': 'polite' }, [common, sci]);
  let speciesId = null;
  let timer = null;

  const render = () => {
    const s = speciesId ? speciesById[speciesId] : null;
    if (!s) return;
    const names = s.names[getLanguage()] ?? s.names.en;
    common.textContent = names.common;
    sci.textContent = names.scientific;
  };
  onLanguageChange(render);

  app.append(root);
  return {
    root,
    /** Show for a species after the configured delay. */
    show(id) {
      speciesId = id;
      render();
      clearTimeout(timer);
      if (!config.ui.speciesLabel) return;
      timer = setTimeout(() => root.classList.add('is-visible'), config.ui.labelDelayS * 1000);
    },
    hide() {
      clearTimeout(timer);
      root.classList.remove('is-visible');
    },
  };
}
